import React, { useState, useRef, useContext, useEffect } from 'react';
import PhotoUploader from '../components/PhotoUploader';
import ImageEditor from '../components/ImageEditor';
import ButtonLarge from './buttonLarge';
import iconScan from '../assets/icon/icon_scan.svg';
import { useNavigate } from 'react-router-dom';
import iconCamera from '../assets/icon/icon_camera.png';

import iconUpload from '../assets/icon/icon_upload.png';
import ButtonOutline from './buttonOutline';
import Button from './button';
import axios from 'axios';
import CONFIG from '../config/apiConfig';
import { clearAnalisa } from '../utils/helper';
import useGuid from './hook/useGuid';
import { ProfileContext } from './context/profileContext';
import Cookies from 'js-cookie';
import InputSelect from './input/inputSelect';
import { useForm } from 'react-hook-form';
import SkinPhotoGuidelinesModal from './SkinPhotoGuidelinesModal';

const CapturePage = () => {
  const { profile } = useContext(ProfileContext);
  const navigate = useNavigate();
  const [mode, setMode] = useState('none');
  const [selectedImage, setSelectedImage] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [uploadResponse, setUploadResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msgError, setMsgError] = useState('');
  const { guid } = useGuid();
  const [bagianTubuh, setBagianTubuh] = useState([]);
  const [showGuidelinesModal, setShowGuidelinesModal] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors }
  } = useForm();

  useEffect(() => {
    fetchBagianTubuh();
  }, []);

  const fetchBagianTubuh = async () => {
    try {
      const response = await axios.get(CONFIG.API_URL + '/bodyparts/lists');
      if (response.data?.status === 200) {
        let list = response.data?.data.map((item) => {
          return { value: item.name, label: item.name };
        });
        setBagianTubuh(list);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Create a reference for the hidden file input
  const fileInputRef = useRef(null);

  // Handle file selection
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setSelectedImage(URL.createObjectURL(selectedFile));
      setMode('editor');
    }
  };

  const handlePhotoSelect = (file) => {
    setSelectedImage(URL.createObjectURL(file));
    setMode('editor');
  };

  const handleCrop = (croppedImageUrl) => {
    setCroppedImage(croppedImageUrl);
  };

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  const handleUpload = async () => {
    if (watch('body_part') === undefined) {
      setMsgError('Bagian tubuh harus dipilih.');
      return;
    }

    setLoading(true);
    setMsgError('');

    const savedData = localStorage.getItem('biodata');
    if (savedData) {
      const biodata = JSON.parse(savedData);
      const payload = {
        body_part: watch('body_part'),
        name: biodata.name,
        email: biodata.email,
        phone_number: biodata.phone,
        gender: biodata.gender,
        birth_date: biodata.date,
        device_info: guid
      };

      if (biodata.event) {
        payload.event = biodata.event;
      }


      if (biodata.referral_code) {
        payload.referral_code = biodata.referral_code;
      }

      var form_data = new FormData();

      for (var key in payload) {
        form_data.append(key, payload[key]);
      }

      var file = dataURLtoFile(croppedImage, 'photo.png');
      form_data.append('image', file);

      try {
        axios
          .post(
            CONFIG.API_URL + '/scan',
            form_data,
            profile
              ? {
                  headers: {
                    Authorization: `Bearer ${Cookies.get('auth_token')}`
                  }
                }
              : {}
          )
          .then(function (response) {
            if (response.data.data.skinive.disease_label === '1B_skin') {
              localStorage.setItem(
                'analisa',
                JSON.stringify({
                  status: 'nopathologies',
                  ...response.data.data
                })
              );
            } else {
              localStorage.setItem(
                'analisa',
                JSON.stringify({
                  status: 'fungil',
                  ...response.data.data
                })
              );
            }

            setLoading(false);
            navigate('/hasil-analisa');
          })
          .catch(function (error) {
            if (error.response.data.message === 'non-fungil') {
              localStorage.setItem(
                'analisa',
                JSON.stringify({
                  status: 'non-fungil',
                  image: croppedImage
                })
              );
              setLoading(false);
              navigate('/hasil-analisa');
            } else {
              setLoading(false);
              setMsgError(error.message);
              clearAnalisa();
              navigate('/hasil-analisa');
            }
          });
      } catch (error) {
        setLoading(false);
        setMsgError(error.message);
        clearAnalisa();
        navigate('/hasil-analisa');
      }
    }
  };

  const toggleModeCamera = () => {
    setShowGuidelinesModal(true);
  };

  const handleContinueToCamera = () => {
    setShowGuidelinesModal(false);
    setMode('camera');
  };

  const triggerFileUpload = () => {
    // Trigger the file input click
    fileInputRef.current.click();
  };

  const toggleModeNone = () => {
    setMsgError('');
    setMode('none');
    setSelectedImage(null);
    setCroppedImage(null);
  };

  return (
    <>
      <SkinPhotoGuidelinesModal
        isOpen={showGuidelinesModal}
        onClose={() => setShowGuidelinesModal(false)}
        onContinue={handleContinueToCamera}
      />
      <div className="p-0 h-full">
        {mode === 'none' && (
          <div className="flex flex-col md:flex-row space-y-5 md:space-y-0 md:space-x-10">
            <button
              onClick={toggleModeCamera}
              className="w-[200px] flex flex-col justify-center border-2 items-center  border-[#BEBEBE] rounded-xl text-black py-4 px-4">
              <img src={iconCamera} alt="" />
              <div className="text-textBlack font-bold">Kamera</div>
            </button>

            {/* This button will trigger file selection */}
            {/* <button
              onClick={triggerFileUpload}
              className="w-[200px] flex flex-col justify-center items-center  border-2 border-[#BEBEBE] rounded-xl text-black py-4 px-4">
              <img src={iconUpload} alt="" />
              <div className="text-textBlack font-bold">Upload file</div>
            </button> */}

            {/* Hidden input for file upload */}
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              style={{ display: 'none' }} // Hide the input
            />
          </div>
        )}

        {mode === 'camera' && (
          <PhotoUploader
            mode={mode}
            onPhotoSelect={handlePhotoSelect}
            onClose={toggleModeNone}
          />
        )}

        {mode === 'editor' && (
          <>
            {selectedImage && !croppedImage && (
              <ImageEditor
                src={selectedImage}
                onCrop={handleCrop}
                onClose={toggleModeNone}
              />
            )}
            {croppedImage && (
              <div className="flex flex-col justify-between h-full items-center">
                <img
                  src={croppedImage}
                  alt=""
                  className="md:max-h-[480px] w-screen md:w-max md:max-w-[720px] object-contain rounded-3xl"
                />

                <div className=" w-full md:w-full md:max-w-[720px] mt-5">
                  <InputSelect
                    label="Bagian Tubuh"
                    options={bagianTubuh}
                    register={register}
                    errors={errors}
                    validation={{
                      name: 'body_part',
                      rules: { required: 'Bagian tubuh harus dipilih' }
                    }}
                  />
                </div>

                <p className="text-red-500 font-semibold mt-1 text-red py-10 h-20">
                  {msgError}
                </p>

                <div className="w-full flex flex-col justify-center items-center mt-5">
                  <div
                    className="w-full flex flex-col justify-center items-center
             md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                    <div className="flex flex-none w-full md:max-w-[200px] px-0 md:px-0">
                      <ButtonOutline
                        label="Foto Lagi"
                        onClick={() => {
                          if (!loading) {
                            toggleModeNone();
                          }
                        }}
                      />
                    </div>
                    <div className="flex flex-none w-full md:max-w-[200px] px-0 md:px-0">
                      <Button
                        loading={loading}
                        label="Proses Foto"
                        onClick={() => handleUpload()}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {uploadResponse && (
              <div className="mt-4">
                <h2 className="text-xl">Hasil Upload:</h2>
                <p>{uploadResponse.message}</p>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default CapturePage;
